import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import Services from '../components/service/Services';
import DigitalEngineeringData from "./../data/digitalEngineering.json";
import CloudComputingData from "../data/cloudComputing.json";
import AIEngineeringData from "../data/AIEngineering.json";
import SAPServicesData from "../data/SAPServices.json";
import DataEngineeringData from "../data/dataEngineering.json";
import InfrastructureData from "../data/infrastructureSupport.json"; 
import { motion } from "motion/react";
const ServicePage = () => {
    const { name } = useParams();
    const navigate = useNavigate();
    const [hasLoaded, setHasLoaded] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const ServiceData = [
        { name: "digital-engineering", data: DigitalEngineeringData },
        { name: "cloud-consulting", data: CloudComputingData },
        { name: "ai-engineering", data: AIEngineeringData },
        { name: "sap-services", data: SAPServicesData },
        { name: "data-engineering", data: DataEngineeringData },
        { name: "infrastructure-support", data: InfrastructureData }
    ];

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });

        // Validate the `name` parameter
        const isValid = /^[a-zA-Z0-9-]+$/.test(name); // Allow letters, numbers, and hyphens only
        if (!isValid) {
            navigate("/404", { replace: true }); // Redirect to NotFound page
            return;
        }

        // Find the corresponding service data
        const filteredData = ServiceData.find(item => item.name === name);
        if (!filteredData) {
            navigate("/404", { replace: true }); // Redirect if service not found
            return;
        }

        setSelectedData(filteredData.data);
        setTimeout(() => setHasLoaded(true), 100);
    }, [name, navigate]);

    if (!hasLoaded) {
        return <p></p>;
    }

    return (    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    > <Services data={selectedData} /> </motion.div>)
};

export default ServicePage;
